/**
 * @class
 */
import Base from '@netx/core/lib/netx-view';
import Template from '../templates/formErrorListView.html';

import ChildViews from '@netx/core/functionality/childViews';

import ChildView from './formErrorListItemView';

class FormErrorListView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.childView = _.extend(
			{
				viewClass: ChildView,
			},
			opts.childView,
		);
		opts.loadingClassObjects = opts.loadingClassObjects || ['collection'];
		opts.template = opts.template || Template;
		super(opts);
	}

	/**
	 * @method
	 * @param {event} e Click event
	 */
	gotoInput(e) {
		this.model.get('input').focus();
	}

	/** @type {string} */
	static get __name__() {
		return 'FormErrorListView';
	}
}

// Functionality
ChildViews(FormErrorListView);

export default FormErrorListView;
